import React, {useState, useEffect} from 'react';
import {useLojasSnap} from "../../lib/DataHooks/lojas";
import {useAppSelector} from "../../lib/hooks";
import {useVeterinariosSnap} from "../../lib/DataHooks/veterinarios";
import {useFazendas} from "../../lib/DataHooks/fazendas";
import {useAgendaProximos} from "../../lib/DataHooks/agenda";
import {agendaDefaultProximosDias} from "../../config";
import {useHistory} from "react-router";
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonItem, IonLabel,
  IonList,
  IonMenuButton, IonPage,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import {pluralize} from "../../lib/utils";
import {EventoDescricao, eventoRequerProdutosUtilizados} from "../../models/Evento";
import {useProprietariosUser} from "../../lib/DataHooks/proprietarios";
import {DateTime} from "luxon";

interface HomeProps {

}

const Home: React.FC<HomeProps> = () => {
  const user = useAppSelector(state => state.app.user);
  const history = useHistory();
  const inicio = DateTime.now().startOf('day');
  const limite = inicio.plus({days: agendaDefaultProximosDias}).endOf('day');

  const [lojas, loadingLojas] = useLojasSnap(
    {userId: user.uid});
  const [veterinarios, loadingVeterinarios] = useVeterinariosSnap(
    {userId: user.uid});
  const [fazendas, loadingFazendas] = useFazendas(
    {userId: user.uid});
  const [tarefas, loadingTarefas] = useAgendaProximos({
    userId: user.uid,
    inicio,
    fim: limite,
  });
  const [proprietarios, loadingProprietarios] = useProprietariosUser(
    {userId: user.uid});

  const [fazendasVips, setFazendasVips] = useState(0);
  const [tarefasAplicacoes, setTarefasAplicacoes] = useState(0);
  const [tarefasSemeadura, setTarefasSemeadura] = useState(0);

  // update fazendas vips
  useEffect(() => {
    if (!loadingFazendas) {
      const n = fazendas.filter(f => f.matriz).length;
      setFazendasVips(n);
    }
  }, [fazendas, loadingFazendas]);

  // update tarefas
  useEffect(() => {
    if (!loadingTarefas) {
      let _aplicacoes = 0;
      let _semeaduras = 0;
      tarefas.forEach(i => {
        if (eventoRequerProdutosUtilizados(i.colecao, i.tipo, i.descricao)) {
          if (i.descricao === EventoDescricao.APLICACAO_ASSISTIDA)
            _aplicacoes += 1;
          if (i.descricao === EventoDescricao.SEMEADURA)
            _semeaduras += 1;
        }
      });

      setTarefasAplicacoes(_aplicacoes);
      setTarefasSemeadura(_semeaduras);
    }
  }, [tarefas, loadingTarefas]);

  return (
    <>
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonMenuButton/>
            </IonButtons>
            <IonTitle>Virbac no Campo</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-padding">
          <div className="text-2xl teste">
            Bem vindo
            {
              user.nome &&
              <span> {user.nome.split(' ')[0]}</span>
            }
          </div>

          <div className="text-gray-800 mt-6 leading-normal">
            O <strong>Virbac no Campo</strong> é uma ferramenta para implementação do Marketing de relacionamento, e tem
            como objetivo auxiliá-lo na gestão de sua base de informações, fornecendo uma visão
            única do cliente. Através do aplicativo, você poderá identificar, diferenciar, interagir
            e personalizar ações para os principais clientes do seu território. Vamos juntos por uma
            Pecuária Rentável e uma equipe de Alta Performance!
          </div>

          <div className="mt-10">
            <div className="text-xl">
              Seu conteúdo cadastrado
            </div>
            <IonList>
              <IonItem
                button={true}
                onClick={() => history.push('/lojas')}
              >
                {loadingLojas &&
                    <IonSkeletonText className="w-full h-4" animated={true}/>
                }
                {lojas &&
                  <IonLabel>
                    {lojas.size} {pluralize('Revenda', lojas.size)} e {pluralize('Cooperativa', lojas.size)}
                  </IonLabel>
                }
              </IonItem>

              <IonItem
                button={true}
                onClick={() => history.push('/veterinarios')}
              >
                {loadingVeterinarios &&
                  <IonSkeletonText className="w-full h-4" animated={true}/>
                }
                {veterinarios &&
                  <IonLabel>
                    {veterinarios.size} {pluralize('Veterinário', veterinarios.size)}
                  </IonLabel>
                }
              </IonItem>

              <IonItem
                button={true}
                onClick={() => history.push('/proprietarios')}
              >
                {
                  loadingProprietarios ?
                    <IonSkeletonText className="w-full h-4" animated={true}/> :
                    <IonLabel>
                      {proprietarios.length} {pluralize('Proprietário', proprietarios.length)}
                    </IonLabel>
                }
              </IonItem>

              <IonItem
                button={true}
                onClick={() => history.push('/fazendas?q=')}
              >
                {
                  loadingFazendas ?
                    <IonSkeletonText className="w-full h-4" animated={true}/> :
                    <IonLabel>
                      {fazendas.length} {pluralize('Fazenda', fazendas.length)}
                    </IonLabel>
                }
              </IonItem>

              <IonItem
                button={true}
                onClick={() => history.push('/fazendas?q=mtt')}
              >
                {
                  loadingFazendas ?
                    <IonSkeletonText className="w-full h-4" animated={true}/> :
                    <IonLabel className="ml-8">
                      {fazendasVips} Possui PI
                    </IonLabel>
                }
              </IonItem>

              <IonItem
                button={true}
                onClick={() => history.push(`/agenda?tab=proximos&dias=${agendaDefaultProximosDias}`)}
                disabled={tarefas.length === 0}
              >
                {
                  loadingTarefas ?
                    <IonSkeletonText className="w-full h-4" animated={true}/> :
                    <>
                      <IonLabel>
                        {tarefas.length} {pluralize('Próximo', tarefas.length)} {pluralize('contato', tarefas.length)} em
                      </IonLabel>
                      <IonLabel slot="end">
                        {agendaDefaultProximosDias} dias
                      </IonLabel>
                    </>

                }
              </IonItem>

              <IonItem
                button={true}
                onClick={() => history.push(`/agenda?tab=proximos&tipo_aplicacoes=1&cliente=fazendas&dias=${agendaDefaultProximosDias}`)}
                disabled={!tarefasAplicacoes}
              >
                {
                  loadingTarefas ?
                    <IonSkeletonText className="w-full h-4" animated={true}/> :
                    <>
                      <IonLabel className="ml-8">
                        {tarefasAplicacoes} {pluralize('Aplicaç', tarefasAplicacoes, 'ão', 'ões')}
                      </IonLabel>
                    </>
                }
              </IonItem>

              <IonItem
                button={true}
                onClick={() => history.push(`/agenda?tab=proximos&tipo_semeadura=1&cliente=fazendas&dias=${agendaDefaultProximosDias}`)}
                disabled={!tarefasSemeadura}
              >
                {
                  loadingTarefas ?
                    <IonSkeletonText className="w-full h-4" animated={true}/> :
                    <>
                      <IonLabel className="ml-8">
                        {tarefasSemeadura} {pluralize('Semeadura', tarefasSemeadura)}
                      </IonLabel>
                    </>
                }
              </IonItem>

            </IonList>
          </div>
        </IonContent>
      </IonPage>
    </>
  );
}

export default Home;
